module.exports = __webpack_public_path__ + "img/259-european-union.cb462712.svg";